import React from "react";

const Institutional: React.FC = () => {
  return (
    <>
      <p className="text-sm text-foreground mb-4">
        LIBSENSE strengthens institutional governance by working with library
        directors and research departments to create the necessary
        infrastructure for open science. This includes providing tools,
        platforms, and resources that support open access to research data and
        publications and fostering a culture of transparency and collaboration.
        Through its capacity-building programs, LIBSENSE is helping African
        institutions position themselves at the forefront of open science,
        ensuring that research and education are more accessible, equitable, and
        impactful.
      </p>
    </>
  );
};

export default Institutional;
